import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-calendar__row" }
const _hoisted_2 = { class: "c-calendar__col" }
const _hoisted_3 = { class: "c-calendar__wrap" }
const _hoisted_4 = { class: "c-calendar" }
const _hoisted_5 = {
  class: "c-calendar__inner",
  "data-lenis-prevent": ""
}
const _hoisted_6 = { class: "c-calendar__header" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "o-title-5 c-calendar__month" }
const _hoisted_9 = { class: "c-calendar__dates" }
const _hoisted_10 = ["onMouseover", "onClick"]
const _hoisted_11 = { class: "o-form c-calendar__form -text-center" }
const _hoisted_12 = { class: "o-checkbox__wrap" }
const _hoisted_13 = ["checked"]
const _hoisted_14 = { class: "c-calendar__col" }
const _hoisted_15 = { class: "c-events__calendar" }
const _hoisted_16 = { class: "c-events__calendar__list" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "c-events__calendar__content" }
const _hoisted_20 = {
  key: 0,
  class: "c-events__calendar__date o-title-5"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = {
  key: 1,
  class: "c-events__calendar__title -text-lg"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 1,
  class: "c-events__calendar__item"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "c-calendar__button",
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.toggleCalendar && $options.toggleCalendar(...args)))
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("span", null, " Calendrier ", -1 /* HOISTED */)),
          _createVNode(_component_Image, {
            id: "calendar",
            class: ""
          })
        ]),
        _createElementVNode("div", {
          class: "c-calendar__mobile-bg",
          onClick: _cache[1] || (_cache[1] = (...args) => ($options.toggleCalendar && $options.toggleCalendar(...args)))
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "c-calendar__mobile-close",
            onClick: _cache[2] || (_cache[2] = (...args) => ($options.toggleCalendar && $options.toggleCalendar(...args)))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, " Fermer ", -1 /* HOISTED */)),
            _createVNode(_component_Image, {
              id: "close",
              class: ""
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                class: "c-calendar__prev",
                onClick: _cache[3] || (_cache[3] = (...args) => ($options.prevMonth && $options.prevMonth(...args))),
                disabled: (parseInt(new Date().toISOString().split('-')[1]) >= $data.currentMonth+1 || $data.currentYear > new Date().getFullYear())
              }, _cache[9] || (_cache[9] = [
                _createElementVNode("span", null, null, -1 /* HOISTED */)
              ]), 8 /* PROPS */, _hoisted_7),
              _createElementVNode("span", _hoisted_8, _toDisplayString($options.currentMonthName) + " " + _toDisplayString($data.currentYear), 1 /* TEXT */),
              _createElementVNode("button", {
                class: "c-calendar__next",
                onClick: _cache[4] || (_cache[4] = (...args) => ($options.nextMonth && $options.nextMonth(...args)))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("span", null, null, -1 /* HOISTED */)
              ]))
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "c-calendar__days" }, [
              _createElementVNode("span", null, "D"),
              _createElementVNode("span", null, "L"),
              _createElementVNode("span", null, "M"),
              _createElementVNode("span", null, "M"),
              _createElementVNode("span", null, "J"),
              _createElementVNode("span", null, "V"),
              _createElementVNode("span", null, "S")
            ], -1 /* HOISTED */)),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dates, (date) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: date.date + '-' + date.otherMonth,
                  class: _normalizeClass(['c-calendar__date', 
                                { 
                                    'is-other-month': date.otherMonth, 
                                    'is-current-date': ((date.date === new Date(this.filterDates.start+'T00:00:00').getDate() || date.date === new Date(this.filterDates.end+'T00:00:00').getDate()) && !date.otherMonth),
                                    'is-disabled': (date.date < $data.today && parseInt(new Date().toISOString().split('-')[1]) >= $data.currentMonth+1), 
                                    'is-today': (date.date === $data.today && parseInt(new Date().toISOString().split('-')[1]) >= $data.currentMonth+1) , 
                                    'is-in-range': (($options.tempDates.includes(date.date) && !date.otherMonth) || ($options.allDates.includes(date.date) && !date.otherMonth))
                                }
                            ]),
                  onMouseover: $event => ($options.setTempDate(date.date)),
                  onClick: $event => ($options.setDates(date.date))
                }, _toDisplayString(date.date), 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_10))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("input", {
                  onChange: _cache[5] || (_cache[5] = (...args) => ($options.changeMonth && $options.changeMonth(...args))),
                  class: "o-checkbox",
                  type: "checkbox",
                  name: "type_spectacles",
                  id: "type_spectacles",
                  checked: $props.filterDates.start == new Date($data.currentYear, $data.currentMonth, 1).toISOString().split('T')[0] && $props.filterDates.end == new Date($data.currentYear, $data.currentMonth + 1, 0).toISOString().split('T')[0]
                }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_13),
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  class: "o-checkbox-label",
                  for: "type_spectacles"
                }, " Afficher le mois au complet ", -1 /* HOISTED */))
              ])
            ]),
            ($props.filterDates.start != '' || $props.filterDates.end != '')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[6] || (_cache[6] = (...args) => ($options.resetCalendar && $options.resetCalendar(...args))),
                  class: "c-calendar__button__reset",
                  "aria-label": "Réinitialiser le calendrier"
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "o-button__text" }, "Réinitialiser le calendrier", -1 /* HOISTED */)),
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "sr-only" }, "Réinitialiser le calendrier", -1 /* HOISTED */)),
                  _createVNode(_component_Image, { id: "reload" })
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createCommentVNode(" Events list "),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          ($props.spectacles.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($options.sortShows, (spectacle) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "c-events__calendar__item",
                  key: spectacle.id
                }, [
                  _createElementVNode("a", {
                    href: spectacle.url,
                    class: "c-events__calendar__image"
                  }, [
                    (spectacle.image)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "c-events__calendar__image__wrap",
                          innerHTML: spectacle.image
                        }, null, 8 /* PROPS */, _hoisted_18))
                      : (_openBlock(), _createBlock(_component_Image, {
                          key: 1,
                          id: "event-placeholder",
                          class: "c-event-card__icon -ico-fill"
                        })),
                    (spectacle.tag)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(spectacle.tag, (tag, slug) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(['-' + slug, "c-event-card__tag"])
                          }, _toDisplayString(tag), 3 /* TEXT, CLASS */))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_17),
                  _createElementVNode("div", _hoisted_19, [
                    (spectacle.representations.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($options.currentDate(spectacle.representations)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("a", {
                      href: spectacle.url,
                      class: "c-events__calendar__artist o-title-3"
                    }, _toDisplayString(spectacle.nom_spectacle), 9 /* TEXT, PROPS */, _hoisted_21),
                    (spectacle.nom_spectacle != spectacle.artiste)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(spectacle.artiste), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "c-events__calendar__separator" }, null, -1 /* HOISTED */)),
                    _createElementVNode("a", {
                      href: spectacle.url,
                      class: "c-events__calendar__button"
                    }, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", null, " Acheter ", -1 /* HOISTED */)),
                      _createVNode(_component_Image, {
                        id: "arrow-up-right",
                        class: "c-event-card__icon"
                      })
                    ], 8 /* PROPS */, _hoisted_23)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            : (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[17] || (_cache[17] = [
                _createElementVNode("div", { class: "c-events__calendar__no-result" }, [
                  _createElementVNode("h2", { class: "o-title-4 u-mb-sm" }, "Aucun spectacle trouvé"),
                  _createElementVNode("p", null, " Aucun spectacle ne correspond à votre recherche. Veuillez modifier vos critères de recherche. ")
                ], -1 /* HOISTED */)
              ])))
        ])
      ])
    ])
  ]))
}